import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';

import { unitPriceBuckets } from 'config/units';
import { formatUSD } from 'utils/format';
import { buildSearchLink } from 'lib/search';

import { Paragraph } from 'components/core/Typography';
import { Card } from 'components/core/Card';
import { Link } from 'components/core/Link';
import { ChevronRight } from 'components/svg';

import './NearbyUnits.scss';

export default function NearbyUnits({ className, pricingBuckets = unitPriceBuckets, nearbyPrices, nearbyZip }) {
	return (
		<div className={classnames(className, 'nearby-units')}>
			<div className="pricing-scroll">
				<div className="card-container">
					{pricingBuckets.map((size) => {
						const lowest = get(nearbyPrices, `${size.key}.price`);
						return lowest && (
							<Card key={size.key}>
								<Paragraph size="small">
									{size.label}
								</Paragraph>
								<Paragraph className="lowest-price">
									Starting at <strong>{formatUSD(lowest)}</strong>
								</Paragraph>
								<Paragraph last>
									<Link
										href={buildSearchLink({
											location: nearbyZip,
											sqft: size.sqft
										})}
										rel="nofollow"
									>
										See more
										<span className="hidden-text">{size.label} units</span> in your area
									</Link>
									<ChevronRight />
								</Paragraph>
							</Card>
						);
					})}
				</div>
			</div>
		</div>
	);
}

NearbyUnits.propTypes = {
	className: PropTypes.string,
	nearbyZip: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	nearbyPrices: PropTypes.object.isRequired,
	pricingBuckets: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			sqft: PropTypes.string.isRequired
		}),
	)
};

